import React from 'react'
import locale from 'shared/i18n/react'
import { CookieModal } from '@viki-ui/gdpr'

const CookieSettingsLink = () => {
  const [isOpen, setIsOpen] = React.useState(false)

  return <React.Fragment>
    <a href='javascript:;' onClick={() => setIsOpen(true)}>{locale.footer.links.cookieSettings}</a>
    <CookieModal
      modalId={'cookie-settings-modal'}
      isOpen={isOpen}
      onClose={() => setIsOpen(false)}
    />
  </React.Fragment>
}

export default CookieSettingsLink



// WEBPACK FOOTER //
// ./assets/js/lib/Gdpr/CookieSettingsLink.jsx